import { render, staticRenderFns } from "./data-processing-page.vue?vue&type=template&id=746970e6&scoped=true"
import script from "./data-processing-page.vue?vue&type=script&lang=js"
export * from "./data-processing-page.vue?vue&type=script&lang=js"
import style0 from "./data-processing-page.vue?vue&type=style&index=0&id=746970e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746970e6",
  null
  
)

export default component.exports